import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/GlobeFill.tsx
const GlobeFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M10.893 2A10 10 0 0 0 2 10.944h5.9a18 18 0 0 1 2.702-8.53c.077-.123.177-.27.29-.414ZM2 12.944a10 10 0 0 0 8.838 8.938 8.732 8.732 0 0 0-.236-.408 18 18 0 0 1-2.702-8.53H2ZM13.062 21.882a10.001 10.001 0 0 0 8.838-8.938H16a18 18 0 0 1-2.702 8.53c-.049.078-.107.181-.172.296l-.064.112ZM21.9 10.944H16a18 18 0 0 0-2.702-8.53 4.625 4.625 0 0 0-.29-.414 10 10 0 0 1 8.892 8.944ZM11.95 4.06a16 16 0 0 1 2.046 6.884H9.903A16 16 0 0 1 11.95 4.06ZM11.95 19.829a16 16 0 0 1-2.047-6.885h4.093a15.999 15.999 0 0 1-2.046 6.885Z",
		fill: props.fill || "currentColor"
	})
}));
export { GlobeFillIcon };
